import _ from 'lodash';

import { ConceptTypes } from '../../constants';

export class ActiveConceptList {
  constructor(name = null, concepts = []) {
    this.name = name;
    this.concepts = concepts;
  }

  equals(sharedList) {
    if (!sharedList) {
      return this.name === null && this.concepts.length === 0;
    }

    if (this.name !== sharedList.name) {
      return false;
    }

  return _.isEqual(
      // Remove ids from active list before comparing them
      this.concepts.map(fieldsCheckedForEquality),
      sharedList.concepts.map(fieldsCheckedForEquality)
    );
  }

  get empty() {
    return this.name == null && this.concepts.length === 0;
  }
}

function restoreName(type, texts) {
  if (!type || !texts) {
    return ''
  }

  return type === ConceptTypes.AND ? texts.join(' & ') : texts.join(',');
}

function fieldsCheckedForEquality(concept) {

  return _.pick(
    {
      ...concept,
      name: concept?.name || restoreName(concept.type, concept.texts),
    },
    ['name', 'texts', 'color']
  );
}
